import React from "react";

export const NavigationContext = React.createContext({ isToggleOn: false, setToggleOn: () => { } });
